import React, { useState } from 'react';
import axios from '../../../library/axios';
import { MySwal } from '../../../library/swal';
import { Button } from 'react-bootstrap';
import { getSlug, } from "../../../config/routes/guards/slug";

const DetailAccreditaionComp = (props) => {

    return (
        <>
            <div className="row">
                <div className="row col-12 mb-3">
                    <div className="col-lg-6 col-12 mb-3">
                        <label className="col-sm-12 col-form-label">
                            Standar Akreditasi
                        </label>
                        <div className="col-12">
                            <input
                                type="text"
                                className="form-control"
                                value={props?.accreditation?.standards_accreditation
                                    ?.Nama}
                                disabled
                            />
                        </div>
                    </div>
                    <div className="col-lg-6 col-12 mb-3">
                        <label className="col-sm-12 col-form-label">
                            Hasil
                        </label>
                        <div className="col-12">
                            <input
                                type="text"
                                className="form-control"
                                value={props?.accreditation?.Hasil || "Belum Terakreditasi"}
                                disabled
                            />
                        </div>
                    </div>
                    <div className="col-lg-4 col-12 mb-3">
                        <label className="col-sm-12 col-form-label">
                            Tgl Mulai Survei
                        </label>
                        <div className="col-12">
                            <input
                                type="date"
                                className="form-control"
                                value={props?.accreditation?.TglMulai}
                                disabled
                            />
                        </div>
                    </div>
                    <div className="col-lg-4 col-12 mb-3">
                        <label className="col-sm-12 col-form-label">
                            Tgl Berakhir Survei
                        </label>
                        <div className="col-12">
                            <input
                                type="text"
                                className="form-control"
                                value={props?.accreditation?.TglBerakhir}
                                disabled
                            />
                        </div>
                    </div>
                    <div className="col-lg-4 col-12 mb-3">
                        <label className="col-sm-12 col-form-label">
                            Status
                        </label>
                        <div className="col-12">
                            <input
                                type="text"
                                className="form-control"
                                value={props?.accreditation?.StatusInNumber === 0 ? "Self Assessment Pokja" : "Verifikasi Tim Mutu"}
                                disabled
                            />
                        </div>
                    </div>
                    <div className="col-lg-4 col-12 mb-3">
                        <label className="col-sm-12 col-form-label">
                            Import Self Assessment
                        </label>
                        <div className="col-12">
                            <input
                                type="text"
                                className="form-control"
                                value={props?.accreditation?.SyncSelfAssessment}
                                disabled
                            />
                        </div>
                    </div>
                    <div className="col-lg-4 col-12 mb-3">
                        <label className="col-sm-12 col-form-label">
                            Active
                        </label>
                        <div className="col-12">
                            <input
                                type="text"
                                className="form-control"
                                value={props?.accreditation?.active === "YES" ? "Ya" : "Tidak"}
                                disabled
                            />
                        </div>
                    </div>
                    <div className="col-lg-4 col-12 mb-3">
                        <label className="col-sm-12 col-form-label">
                            Created At
                        </label>
                        <div className="col-12">
                            <input
                                type="text"
                                className="form-control"
                                value={props?.accreditation?.createdAt}
                                disabled
                            />
                        </div>
                    </div>
                </div>
                <div className="col-12">
                    <Button variant="danger" size="sm" onClick={() => props.close()}>
                        Tutup
                    </Button>
                </div>
            </div>
        </>
    );
};

export default DetailAccreditaionComp;
